export default __webpack_public_path__ + "static/media/questionmark.5a39db14.png";